import { render, staticRenderFns } from "./MServTopListComp.vue?vue&type=template&id=528f80de&"
import script from "./MServTopListComp.vue?vue&type=script&lang=js&"
export * from "./MServTopListComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports